import { AmLogo, DesktopImage } from '@approvalmax/ui';
import { Box, Button, Grid, List, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { memo, useMemo } from 'react';
import { useMount } from 'react-use';
import { amplitudeService } from 'services/amplitude';

import { getSignupType } from './Content.helpers';
import { useSendLinkButtons } from './Content.hooks';
import { messages } from './Content.messages';

export const Content = memo(() => {
    const profile = useSelector(selectors.profile.findProfile);

    const signupType = useMemo(() => getSignupType(), []);

    const {
        handleSendNow,
        isTimerActiveNow,
        resendTimeNow,
        isSendNowDisabled,
        handleSendTomorrow,
        isTimerActiveTomorrow,
        resendTimeTomorrow,
        isSendTomorrowDisabled,
    } = useSendLinkButtons(profile?.id, signupType);

    useMount(() => {
        amplitudeService.sendData('signup: land on block screen for mobile', {
            user_id: profile?.id,
            signup_type: signupType,
        });
    });

    return (
        <Grid alignItems='center' justifyContent='center' height='100%'>
            <Box spacing='24 12' maxWidth={500}>
                <Grid alignItems='center' gap={24}>
                    <Grid justifyContent='center'>
                        <AmLogo width={161} height={24} />
                    </Grid>

                    <Grid justifyContent='center'>
                        <DesktopImage width={100} height={100} />
                    </Grid>

                    <Text font='headline' fontSize='xxsmall' fontWeight='medium' textAlign='center'>
                        {messages.title}
                    </Text>

                    <Text font='body' fontSize='small'>
                        <List as='ol'>
                            <List.Item>
                                {messages.listItem1({
                                    br: <br />,
                                })}
                            </List.Item>

                            <List.Item>{messages.listItem2}</List.Item>
                        </List>
                    </Text>

                    <Text font='body' fontSize='medium' textAlign='center'>
                        {messages.description}
                    </Text>

                    <Grid gap={16}>
                        <Button
                            block
                            size='medium'
                            color='blue80'
                            disabled={isTimerActiveNow || isSendNowDisabled}
                            onClick={handleSendNow}
                        >
                            {isTimerActiveNow ? resendTimeNow : messages.buttonSendNow}
                        </Button>

                        <Button
                            block
                            size='medium'
                            color='blue80'
                            disabled={isTimerActiveTomorrow || isSendTomorrowDisabled}
                            onClick={handleSendTomorrow}
                            variant='outline'
                        >
                            {isTimerActiveTomorrow ? resendTimeTomorrow : messages.buttonSendTomorrow}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
});

Content.displayName = 'Content';
